'use strict';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Widget } from '../../decorator/widget.decorator';
import { IWidgetItem } from '../../interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/shared/dynamic-form/interfaces/IdynamicFormItem';
import { Subscription } from 'rxjs';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { PasswordEditorDetailsComponent } from './password-editor-details/password-editor-details.component';
import { DynamicFormItem } from '@ispm/shared/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/shared/dynamic-form/constants/ItemsTypes';
import { get, cloneDeep } from 'lodash';
import { PasswordEditorMode, PasswordEditorSettings } from './password-editor-settings';

@Widget('PasswordEditor')
@Component({
  selector: 'ispm-password-editor',
  templateUrl: './password-editor.component.html',
  styleUrls: ['./password-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordEditorComponent implements OnInit, IWidgetItem {
  private modalSubscriber$: Subscription;
  private widgetConfigPayload: any;
  private itemBuilt: boolean = false;
  private currentPassword: string;
  private _widgetDisabledStatus: boolean;
  public formData: {};
  public dynamicFormConfig: DynamicFormItem[];
  public passwordExists: boolean;
  public widgetUpdateValueCallback: (value) => void;
  public readOnly: boolean = false;
  set widgetDisabledStatus(value) {
    this._widgetDisabledStatus = value;
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  get widgetDisabledStatus() {
		return this._widgetDisabledStatus;
  }

  constructor(private modalLoader: DynamicModalLoaderService,
              private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() { }

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    const widgetPayload = get(widgetConfig, 'widgetPayload', { });
    Object.assign(this, widgetPayload);
    this.widgetConfigPayload = widgetPayload;
    this.readOnly = get(widgetConfig, 'attributes.previewOnly', false);
  }

  set widgetData(widgetData: any) {
    this.currentPassword = widgetData && widgetData['value'] ? widgetData['value'] : widgetData;
    if (!this.itemBuilt){
      this.itemBuilt = true;
      this.dynamicFormConfig = [DynamicFormItem.builder(this.widgetConfigPayload.label || ' ',
        PasswordEditorSettings.PASSWORD_FIELD_NAME, ITEMS_TYPES.TEXT).setCssClass('password-input-wrapper df-item-size-100')];

    }
    this.passwordExists = !!widgetData;
    const itemValue: string = this.passwordExists ? PasswordEditorSettings.PASSWORD_PLACE_HOLDER : '';
    this.formData = {password: itemValue};
    this.dynamicFormConfig[0].setDefault(itemValue);
    this.refreshUI();
  }

  refreshUI(){
    this.formData = cloneDeep(this.formData);
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  openEncryptForm(){
    this.launchPasswordDetailsForm(PasswordEditorMode.Encrypt);
  }

  openDecryptForm(){
    this.launchPasswordDetailsForm(PasswordEditorMode.Decrypt);
  }

  launchPasswordDetailsForm(formMode: PasswordEditorMode) {
    const title: string = formMode === PasswordEditorMode.Decrypt ? 'Decrypt' : 'Encrypt';
    const passwordValue: string = formMode === PasswordEditorMode.Decrypt ? this.currentPassword.toString() : '';
    const buttons = formMode === PasswordEditorMode.Decrypt ? {approveBtn: 'Ok'} : {approveBtn: 'Ok', declineBtn: 'Cancel'};
    this.modalSubscriber$ = this.modalLoader.popupModal(PlaceholderModalComponent,
      {
        title: title,
        componentToLoad: PasswordEditorDetailsComponent,
        buttons: buttons,
        payload: {password: passwordValue, formMode: formMode},
        approveCallback: () => {
        },
      })
      .filter(response => response.payload)
      .map(response => response.payload)
      .subscribe((passwordResult) => {
        if (formMode === PasswordEditorMode.Encrypt && passwordResult.payload && passwordResult.payload[PasswordEditorSettings.PASSWORD_FIELD_NAME]) {
          this.currentPassword = passwordResult.payload[PasswordEditorSettings.PASSWORD_FIELD_NAME];
          if (this.currentPassword) {
            this.passwordExists = true;
            this.formData[PasswordEditorSettings.PASSWORD_FIELD_NAME] = PasswordEditorSettings.PASSWORD_PLACE_HOLDER;
            this.widgetUpdateValueCallback.apply(this, [this.currentPassword]);
            this.refreshUI();
          }
        }
        this.modalSubscriber$.unsubscribe();
        this.modalSubscriber$ = null
      })
  }
}

